import { LicenseStatusResource } from "client/resources/licenseStatusResource";

export class LicenseResource extends LicenseStatusResource {
    UseFreeVersion: boolean;
    LicenseText: string;
    LicenseKey: string;
}

export default LicenseResource;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/licenseResource.ts